import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar]);

if ($('.team__slick').length > 0) {
	var swiperHome = $('.team__slick');
	swiperHome.each(function () {
		var mySwiper = new Swiper(this, {
			slidesPerView: 3,
			spaceBetween: 0,
			slidesPerGroup: 1,
			centeredSlides: true,
			loop: true,
			speed: 1000,
			mousewheelControl: true,
            mousewheelForceToAxis: true,
            mousewheelSensitivity: 1,
            mousewheelReleaseOnEdges: false,
			mousewheel: {
				releaseOnEdges: true,
			},
			autoplay: {
				delay: 1500,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".swiper-arrow-next",
				prevEl: ".swiper-arrow-prev",
			},
			breakpoints: {
				310: {
					slidesPerView: 1.2,
					slidesPerGroup: 1,
					centeredSlides: true,
				},
				760: {
					slidesPerView: 2.6,
					slidesPerGroup: 1,
				},
				1010: {
					slidesPerView: 2.6,
					slidesPerGroup: 1,
				},
				1200: {
					slidesPerView: 3,
					slidesPerGroup: 1,
				}
			},
		});
	});
}


